// extracted by mini-css-extract-plugin
export default {"paytype":"PayRecordTable_paytype__31rLS","null_content":"PayRecordTable_null_content__7sEEH","tableBox":"PayRecordTable_tableBox__+-viQ"};